var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({class:_vm.concatClasses,attrs:{"to":_vm.to}},"router-link",_vm._d({},[_vm.typeLink,true])),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }